import { render } from "./DetailCalendar.vue?vue&type=template&id=e45aa202&scoped=true"
import script from "./DetailCalendar.vue?vue&type=script&lang=js"
export * from "./DetailCalendar.vue?vue&type=script&lang=js"

import "./DetailCalendar.vue?vue&type=style&index=0&id=e45aa202&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Tegra\\abrafarma\\abrafarma-app-ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e45aa202"]])

export default __exports__